import {Field, Label, Toggle} from "@zendeskgarden/react-forms";
import {Tooltip} from "@zendeskgarden/react-tooltips";
import {ReactElement} from "react";
import {IoHelpCircleOutline} from "react-icons/io5";
import * as css from "../styles/metric-controls.module.scss";
import {IUseRevenueWizardState} from "../logic/useRevenueWizard";
import {GardenPlacement} from "@zendeskgarden/react-tooltips/dist/typings/types";


interface IRoundingControlsProps {
    revenueWizardInstance: IUseRevenueWizardState;
    standalone?: boolean;
    tooltipPlacement: GardenPlacement;
}

export default function RoundingControls({revenueWizardInstance, standalone, tooltipPlacement}: IRoundingControlsProps): ReactElement {
    const {
        forceRounding,
        setForceRounding,
    } = revenueWizardInstance;

    return (
        <div className={`${css.metricControls} ${css.roundingControls} ${standalone && css.isStandalone}`}>
            <Field>
                <Toggle
                    checked={forceRounding}
                    onChange={(evt) => setForceRounding(evt.target.checked)}
                    aria-label="toggle rounding"
                >
                    <Label>
                        <Tooltip
                            className={css.tooltip}
                            size="medium"
                            placement={tooltipPlacement}
                            content="If you have a Target Occupancy of 85%, and a Unit Type with 10 units, your Occupied Unit Count would be 8.5. With rounding enabled, we would automatically adjust your Occupancy to 90%."
                            zIndex={4}
                        >
                            <div>Round to Whole Units <IoHelpCircleOutline className={css.hintIcon} /></div>
                        </Tooltip>
                    </Label>
                </Toggle>
            </Field>
        </div>
    );
}
